export var APPLICATION_NAME = '@ori/login-sidebar';
export var CONSULTANT_NUMBER_QUERY_PARAM_KEY = 'chPwdUsr';
export var DESKTOP_BREAKPOINT = 1024;
export var RETURN_URL_QUERY_PARAM_KEY = 'returnUrl';
export var CHANGE_PASSWORD_URL = '/system/ajax/LoginApi/ChangePassword';
export var DO_LOGIN_URL = '/system/ajax/LoginApi/DoLogin';
export var VALIDATE_LOGIN_URL = '/system/ajax/LoginApi/ValidateLogin';
export var TEMPORARY_PASSWORD_URL = '/system/ajax/LoginApi/SendTemporaryPassword';
export var CHANGE_FORGOTTEN_PASSWORD_URL = '/system/ajax/LoginApi/ChangeForgottenPassword';
export var BUSINESS_OPPORTUNITY_URL = '/business-opportunity';
export var EXTERNAL_ACCOUNT_URL = '/system/ajax/LoginApi/ConnectExternalAccount';
/**
 * Translations endpoint
 */

export var TRANSLATIONS_ENDPOINT = '/system/ajax/Localization/Translate';
export var JOIN_TILES = 'JoinTiles';
export var STATUS_NOT_FOUND = 404;
export var STATUS_BAD_REQUEST = 400;
export * from './internalCodeTranslationKeys';
export * from './swrConfig';